module.exports = __webpack_public_path__ + "img/sleeve ruffle width.f5d9a4a4.png";